// FlightListItem — Presentational single added-flight row (airline/flightNumber,
// departure→arrival + optional gate, and an X remove button).
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// icon, and disabled/opacity guards are identical to the source.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { X } from 'lucide-react';

export const FlightListItem = React.memo(function FlightListItem({ flight, index, isCreating, onRemove }) {
  return (
    <div
      style={{
        padding: '12px 16px',
        background: '#f0f9ff',
        border: '1px solid #bae6fd',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}
    >
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '16px', fontWeight: '600', color: '#1f2937', marginBottom: '4px' }}>
          {flight.airline} {flight.flightNumber}
        </div>
        <div style={{ fontSize: '14px', color: '#6b7280' }}>
          {flight.departureAirport} → {flight.arrivalAirport}
          {flight.departureGate && ` • Gate ${flight.departureGate}`}
        </div>
      </div>
      <button
        type="button"
        onClick={() => onRemove(index)}
        disabled={isCreating}
        style={{
          background: 'none',
          border: 'none',
          cursor: isCreating ? 'not-allowed' : 'pointer',
          padding: '4px',
          borderRadius: '4px',
          color: '#dc2626',
          opacity: isCreating ? 0.5 : 1,
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <X size={18} />
      </button>
    </div>
  );
});

export default FlightListItem;
